export const DEFAULT_USER_INFO = {
    email: '',
    id: '',
    masterId: '',
    roles: [],
    userName: '',
};

export const DEFAULT_CONTACTS = [
    {
        agencyPhones: ['+7 (812) 309-26-66'],
        city: {
            cityFromId: 1264,
            countryId: 4,
            countryName: 'Россия',
            departureCityId: 1264,
            guid: 'ff54c417-9f81-4e21-8e18-475e5f5c5bfe',
            id: 326,
            latitude: 59.93772,
            longitude: 30.313622,
            name: 'Санкт-Петербург',
            originalName: null,
            parentCityId: null,
            populationKind: 1,
            regionName: 'Санкт-Петербург',
        },
        touristPhones: ['+7 (812) 309-43-29'],
    },
];

export const DEFAULT_CONTACT_EMAILS = {
    agencyEmail: 'tour@sletat.ru',
    touristEmail: 'info@sletat.ru',
};

export const DEFAULT_CONTACT_PHONES = {
    touristPhones: ['+7 (812) 309-43-29'],
};

export const DEFAULT_DURATION_DEPARTURE_RANGE = 2;
